import {buildAccountItemsFromConfig} from '#core/utils/intent-factory.js';
import {mergeTo} from '#core/utils/config-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';
import {MyAccountHeadMetaFactory} from '#core/application/seo/head-meta-factory.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Account} from '../account.js';

import {myAccountPageFactory} from './my-account-page.factory';

import PALETTE_SCHEMA from './my-account-page.palette-schema.yaml';

class MyAccountPageFeature extends AbstractVisualFeature {
    get name() {
        return 'MyAccountPage';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return myAccountPageFactory(PALETTE);
    }

    updateViewsConfig(viewsConfig) {
        mergeTo(viewsConfig, {
            MyAccountPageView: {
                documentHeadMetaFactory: MyAccountHeadMetaFactory,
                menuSections: buildAccountItemsFromConfig(ApplicationConfig.config.myAccountViewItems),
                linkMenu: {
                    showExtraItemDetails: true,
                },
            },
        });

        super.updateViewsConfig(viewsConfig);
    }
}

export const MyAccountPage = new MyAccountPageFeature(Account);
